import { Injectable } from '@angular/core';
import {CustomFieldValues} from '../include/structures';
import {WSService} from '../include/service'
import { Globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class CustomfieldvaluesService extends WSService<CustomFieldValues> {

  constructor() {super("customfieldvalues") }

  saveCustomTable(table:String,data: any,oncomplete:any): void {
   Globals.ws.send<any>("customfieldvalues","saveCustomTable",{table:table,data:data},[],oncomplete);
  }


}
